module.exports = __webpack_public_path__ + "images/wxwork/img-wcwf-2@2x-8cf683052a31288db6d86372b08e5666.png";